// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-container {
	display: flex;
	justify-content: center;
	margin-top: 100px;
}

.profile-card {
	background-color: #ffffff;
	border: 1px solid #ccc;
	border-radius: 8px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	width: 1100px;
	margin: 100px 0;
}

.card-header {
	background-color: var(--primary-color);
	color: #ffffff;
	border-radius: 8px 8px 0 0;
	padding: 15px;
	text-align: center;
}

.card-title {
	margin: 0;
	font-size: 2rem;
}

.profile-row {
	margin-top: 20px;
}

.profile-row.grid {
	display: grid;
	grid-template-columns: auto auto auto;
}

.profile-col {
	flex: 1 1;
	margin: 10px;
	min-width: 250px;
}

.form-label {
	display: block;
	margin-bottom: 8px;
	font-weight: bold;
	color: #333;
}

select {
	font-size: 1rem;
}

.form-input {
	width: 100%;
	padding: 10px;
	border: 1px solid #ddd;
	border-radius: 5px;
	font-size: 1rem;
	background-color: #f9f9f9;
}

.form-input:disabled {
	background-color: rgb(232, 240, 254) !important;
}

.form-input:not([value=""]):not(.form-input:focus) {
	background-color: #f9f9f9;
}

.profile-picture {
	border: 3px solid var(--secondary-color);
	border-radius: 50%;
	width: 130px;
	height: 130px;
	display: flex;
	justify-content: center;
	align-items: center;
	overflow: hidden;
}

.profile-image {
	width: 100%;
	height: 100%;
	object-fit: cover;
	border-radius: 50%;
}

.profile-button-container {
	width: 100%;
	display: flex;
	justify-content: end;
	align-items: center;
	flex-direction: row-reverse;
	margin-top: 30px;
}

.profile-button {
	width: 100px;
	font-size: 20px;
	height: 50px;
	margin: 10px;
	background-color: var(--success-color);
}

.profile-button:hover {
	background-color: rgb(5, 142, 5);
}

.update-profile-button {
	font-size: 18px;
	width: 150px;
	background-color: rgb(0, 158, 186);
}

.update-profile-button:hover {
	background-color: rgb(1, 135, 158);
}

@media (max-width: 768px) {
	.card-title {
		font-size: 25px;
	}

	.profile-row {
		flex-direction: column;
	}

	.profile-col {
		min-width: 100%;
	}

	.profile-row.grid {
		grid-template-columns: auto auto;
	}

	.profile-picture {
		width: 90px;
		height: 90px;
	}
}
`, "",{"version":3,"sources":["webpack://./src/pages/Profile/Profile.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,uBAAuB;CACvB,iBAAiB;AAClB;;AAEA;CACC,yBAAyB;CACzB,sBAAsB;CACtB,kBAAkB;CAClB,wCAAwC;CACxC,aAAa;CACb,eAAe;AAChB;;AAEA;CACC,sCAAsC;CACtC,cAAc;CACd,0BAA0B;CAC1B,aAAa;CACb,kBAAkB;AACnB;;AAEA;CACC,SAAS;CACT,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,qCAAqC;AACtC;;AAEA;CACC,SAAO;CACP,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,iBAAiB;CACjB,WAAW;AACZ;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,aAAa;CACb,sBAAsB;CACtB,kBAAkB;CAClB,eAAe;CACf,yBAAyB;AAC1B;;AAEA;CACC,+CAA+C;AAChD;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,wCAAwC;CACxC,kBAAkB;CAClB,YAAY;CACZ,aAAa;CACb,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,aAAa;CACb,oBAAoB;CACpB,mBAAmB;CACnB,2BAA2B;CAC3B,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,YAAY;CACZ,YAAY;CACZ,sCAAsC;AACvC;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,YAAY;CACZ,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC;EACC,eAAe;CAChB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,gCAAgC;CACjC;;CAEA;EACC,WAAW;EACX,YAAY;CACb;AACD","sourcesContent":[".profile-container {\n\tdisplay: flex;\n\tjustify-content: center;\n\tmargin-top: 100px;\n}\n\n.profile-card {\n\tbackground-color: #ffffff;\n\tborder: 1px solid #ccc;\n\tborder-radius: 8px;\n\tbox-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n\twidth: 1100px;\n\tmargin: 100px 0;\n}\n\n.card-header {\n\tbackground-color: var(--primary-color);\n\tcolor: #ffffff;\n\tborder-radius: 8px 8px 0 0;\n\tpadding: 15px;\n\ttext-align: center;\n}\n\n.card-title {\n\tmargin: 0;\n\tfont-size: 2rem;\n}\n\n.profile-row {\n\tmargin-top: 20px;\n}\n\n.profile-row.grid {\n\tdisplay: grid;\n\tgrid-template-columns: auto auto auto;\n}\n\n.profile-col {\n\tflex: 1;\n\tmargin: 10px;\n\tmin-width: 250px;\n}\n\n.form-label {\n\tdisplay: block;\n\tmargin-bottom: 8px;\n\tfont-weight: bold;\n\tcolor: #333;\n}\n\nselect {\n\tfont-size: 1rem;\n}\n\n.form-input {\n\twidth: 100%;\n\tpadding: 10px;\n\tborder: 1px solid #ddd;\n\tborder-radius: 5px;\n\tfont-size: 1rem;\n\tbackground-color: #f9f9f9;\n}\n\n.form-input:disabled {\n\tbackground-color: rgb(232, 240, 254) !important;\n}\n\n.form-input:not([value=\"\"]):not(.form-input:focus) {\n\tbackground-color: #f9f9f9;\n}\n\n.profile-picture {\n\tborder: 3px solid var(--secondary-color);\n\tborder-radius: 50%;\n\twidth: 130px;\n\theight: 130px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\toverflow: hidden;\n}\n\n.profile-image {\n\twidth: 100%;\n\theight: 100%;\n\tobject-fit: cover;\n\tborder-radius: 50%;\n}\n\n.profile-button-container {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: end;\n\talign-items: center;\n\tflex-direction: row-reverse;\n\tmargin-top: 30px;\n}\n\n.profile-button {\n\twidth: 100px;\n\tfont-size: 20px;\n\theight: 50px;\n\tmargin: 10px;\n\tbackground-color: var(--success-color);\n}\n\n.profile-button:hover {\n\tbackground-color: rgb(5, 142, 5);\n}\n\n.update-profile-button {\n\tfont-size: 18px;\n\twidth: 150px;\n\tbackground-color: rgb(0, 158, 186);\n}\n\n.update-profile-button:hover {\n\tbackground-color: rgb(1, 135, 158);\n}\n\n@media (max-width: 768px) {\n\t.card-title {\n\t\tfont-size: 25px;\n\t}\n\n\t.profile-row {\n\t\tflex-direction: column;\n\t}\n\n\t.profile-col {\n\t\tmin-width: 100%;\n\t}\n\n\t.profile-row.grid {\n\t\tgrid-template-columns: auto auto;\n\t}\n\n\t.profile-picture {\n\t\twidth: 90px;\n\t\theight: 90px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
